module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/mentors__09-001468db79741d927e0afbc731d32270.jpg";